"use client";

import Link from "next/link";
import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { forceMainThreadAnimation } from "@/utils/motion";

// Schwebender Zurück-Link: erscheint ab leichtem Scroll als Pill UNTER dem
// Header und floatet über dem Content mit. Ganz oben übernimmt der normale
// Flow-Link (.page-back). Der Scroller der Site ist <main>.
export default function FloatingBackLink({ href, label }: { href: string; label: string }) {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const scroller = document.querySelector('main');
    if (!scroller) return;
    const onScroll = () => setScrolled(scroller.scrollTop > 160);
    scroller.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => scroller.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <AnimatePresence>
      {scrolled && (
        <motion.div
          className="page-back-floating"
          initial={{ opacity: 0, y: -12 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -12 }}
          transition={{ duration: 0.25, ease: 'easeOut' }}
          onUpdate={forceMainThreadAnimation}
        >
          <Link href={href} className="no-select">← {label}</Link>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
